__turbopack_context__.v({
  "code": "DemoContent-module__5IzRhq__code",
  "codeBlock": "DemoContent-module__5IzRhq__codeBlock",
  "codeSection": "DemoContent-module__5IzRhq__codeSection",
  "container": "DemoContent-module__5IzRhq__container",
  "demoSection": "DemoContent-module__5IzRhq__demoSection",
  "demoSurface": "DemoContent-module__5IzRhq__demoSurface",
});
